export interface EmbedTokenModel {
    token: string,
    tokenId: string,
    expiration: Date | null,
}

export const embedTokenModelInitial: EmbedTokenModel = {
    token: '',
    tokenId: '',
    expiration: null
};